export enum TrendConfigurationTypeEnum {
    //    None = 0,
    //    All = 1,
        Device = 2,
        Group = 3,
        Well = 6
    }